
<div style="margin: 5px; padding-top: 5px; background-color: #424242; font-family:Roboto; min-width: 270px; max-width: 270px; border-style: solid; border-color: gray;" class="mat-elevation-z5"  [ngStyle]="{'border-width': ((this.Game.HomeTeamTags && this.Game.HomeTeamTags.length>0) || (this.Game.AwayTeamTags && this.Game.AwayTeamTags.length>0)) ? '2px' : '0px'}" >
  <div style="color: darkgray;">
    {{this.Game.DivisionName}}
  </div>
  <div style="display: flex; margin: 5px 5px 5px 5px;"   (click)="openGameDetails(this.Game.GameId)" matRipple matRippleColor="'red''">
    @if (ShowDate()) {
      <div style="font-size: x-large;">
        {{this.Game.GameDate | date: 'dd'}}<br>
        {{this.Game.GameDate  | date: 'LLL'}}
      </div>
    }

    <div style="display: block; width: 100%">
      <table style="width: 100%;">
        <tr>
          <td style="text-align: center; width: 33%;height: 50px;">
            @if (this.Game.HomeTeamSmallIcon) {
              <img style="height: 50px;" [src]="'../../assets/img/' + this.Game.HomeTeamSmallIcon">
            }
            @if (this.Game.HomeTeamSmallIconFileName) {
              <img  style="height: 50px;" [src]="'../../assets/img/' + this.Game.HomeTeamSmallIconFileName">
            }</td>
            <td style="width: 33%;font-size: small; text-align: center; color: darkgray;vertical-align: top;;">
              <!-- User selected to view in Local game timezone -->
              @if (this.DateDisplay()=='GameDate') {
                <div style="font-size: large; color:white;">{{this.Game.GameTime | date: 'HH:mm'}}</div>
                <mat-divider></mat-divider>
                <!-- <div style="font-size: small; margin-right: 5px;">
                {{this.Game.GameDate | date:'MMM dd HH:mm' }}
              </div>-->
              @if (this.Game.ArenaTimeZoneIana!=null) {
                <div class="timezone"> {{this.Game.ArenaTimeZoneIana}}</div>
              }
            }

            <!-- User selected to view in Local user timezone -->
            @if (this.DateDisplay()=='GameTimeUTC') {
              @if (this.Game.ArenaTimeZoneIana==null) {
                <!-- no data for the local timezone set-->
                <!--   <div style="font-size: large; color:gray;">
                {{this.Game.GameDate | date: 'MMM dd'}}
              </div> -->
              <div style="font-size: large; color:gray;">
                {{this.Game.GameTime | date: 'HH:mm'}}
              </div>
              <div class="timezone_notfound">
                Local timezone
              </div>
            }
            @if (this.Game.ArenaTimeZoneIana!=null) {
              <!--  local timezone set-->
              <div style="display:flex; flex-direction: column;">
                <div style="font-size: large; margin-right: 5px;color:white;">
                  {{this.Game.GameTimeUTC | date:'HH:mm' }}
                </div>
                <!-- <div class="timezone"> {{this.Game.ArenaTimeZoneIana}}</div> -->
              </div>
            }
          }
          <div style="color:white;">{{this.Game.Venue}}</div>
        </td>
        <td style="text-align: center;width: 33%;">
          @if (this.Game.AwayTeamSmallIcon) {
            <img style="height: 50px;" [src]="'../../assets/img/' + this.Game.AwayTeamSmallIcon">
          }
          @if (this.Game.AwayTeamSmallIconFileName) {
            <img style="height: 50px;" [src]="'../../assets/img/' + this.Game.AwayTeamSmallIconFileName">
          }
        </td>


      </tr>

    </table>

    <div style="display: flex; justify-content: space-between;flex-direction: row; width: 100%; font-size: small;">
      <div>{{this.Game.HomeTeamName}}</div>
      <div>{{this.Game.AwayTeamName}}</div>
    </div>
    <!--  <div style="display:flex; flex-direction: row;">
    <div style="font-size: small; margin-right: 5px;">
      {{this.Game.GameTimeUTC | date:'MMM dd HH:mm' }}
    </div>
    <div class="timezone"> {{currentTimeZone()}}</div>
  </div> -->
</div>

<div></div>
<div></div>
</div>
<!--     <div *ngIf="!((this.Game.HomeTeamTags && this.Game.HomeTeamTags.length>0) || (this.Game.AwayTeamTags && this.Game.AwayTeamTags.length>0))  " style="margin-left: 5px; font-size: small; color: darkgray; height: 40px;">
</div> -->
@if ((this.Game.HomeTeamTags && this.Game.HomeTeamTags.length>0) || (this.Game.AwayTeamTags && this.Game.AwayTeamTags.length>0)  ) {
  <div
  style="margin-left: 5px; font-size: small; color: darkgray;"></div>
}
<div style="display: flex; justify-content: space-between;flex-direction: row; width: 100%; font-size: small;">
  <div style="margin-left: 5px; display: flex; flex-direction: row;">
    <!--    <mat-icon *ngFor="let tag of this.Game.HomeTeamTags" [class]="tag.TagColor">label</mat-icon> -->
    @for (tag of this.Game.HomeTeamTags; track tag) {
      <div [class]="tag.TagColor"
        style="font-size: small; border-radius: 3px;  margin-right: 3px;    ">
        {{tag.TagName}}
      </div>
    }
  </div>
  <div style="margin-right: 5px; display: flex; flex-direction: row;">
    <!-- <mat-icon *ngFor="let tag of this.Game.AwayTeamTags" [class]="tag.TagColor">label</mat-icon> -->
    @for (tag of this.Game.AwayTeamTags; track tag) {
      <div [class]="tag.TagColor"
        style="font-size: small; border-radius: 3px; margin-right: 3px;   ">
        {{tag.TagName}}
      </div>
    }
  </div>
</div>
<div  style=" background-color: #424242; font-family:Roboto; min-width: 270px; max-width: 270px;" >
  @if (!this.Game.IsInMySchedule) {
    <button mat-icon-button (click)="addGameToSchedule()" matTooltip="ADD TO MY SCHEDULE">
      <span class="material-symbols-outlined">
        calendar_add_on
      </span>
    </button>
  }

  @if (this.Game.IsInMySchedule) {
    <button mat-icon-button (click)="removeGameFromSchedule()"
      matTooltip="REMOVE FROM MY SCHEDULE">
      <span class="material-symbols-outlined" style="color: indianred;">
        event_busy
      </span>
    </button>
  }

</div>

</div>

